{
  "backButton": "Volver a {prevMenuButton}",
  "moreActions": "Más acciones",
  "unavailable": "No disponible, ampliar para más detalles"
}
